import React from "react"
import { connect } from "react-redux"

import PlanBuilder from "components/plan-builder/plan-builder"

import {
  getPlanBuilderData,
  getPlanBuilderCost
} from "../../redux/selectors/plan-selectors"
import { builtPlan } from "../../redux/actions/basket-actions"
import PropTypes from "prop-types"
import { prevPage, nextPage } from "redux/actions/journey-actions"

// import { nextPage, jumpPage } from "./../../redux/actions/journey-actions"

const BuildPlanPage = ({
  planBuilderData,
  calcCost,
  onBuildPlan,
  gotoNextPage,
  benefits,
  gotoPrevPage
}) => {
  const handleBuildPlan = (upfront, duration, data, cost) => {
    onBuildPlan(upfront, duration, data, cost)
    gotoNextPage()
  }

  return (
    <>
      <PlanBuilder
        data={planBuilderData}
        calcCost={calcCost}
        onBuildPlan={handleBuildPlan}
        benefits={benefits}
      />
      <div className="back-button-container">
        <button className="back-button" onClick={gotoPrevPage}>
          Back
        </button>
      </div>
    </>
  )
}

BuildPlanPage.propTypes = {
  planBuilderData: PropTypes.object.isRequired,
  calcCost: PropTypes.func.isRequired,
  onBuildPlan: PropTypes.func.isRequired,
  gotoNextPage: PropTypes.func.isRequired,
  benefits: PropTypes.array,
  gotoPrevPage: PropTypes.func.isRequired
}

// TODO: Get the build a plan options to the plan builder
// TODO: Mechanisms to send the built plan to Redux

const mapStateToProps = state => ({
  planBuilderData: getPlanBuilderData(state),
  calcCost: getPlanBuilderCost(state),
  benefits: getPlanBuilderData(state).benefits.map(benefitData => {
    if (typeof benefitData === "string") {
      return {
        benefit: state.benefits.byID[benefitData]
      }
    }

    return {
      benefit: state.benefits.byID[benefitData.id],
      condition: benefitData.condition
    }
  })
  // plans: getPlanData(state),
  // planStyle: getPlanStyle(state),
  // maximumToShow: getMaximumNumberOfPlansToDisplay(state),
  // defaultPlan: getDefaultPlan(state),
  // excludeVAT: state.plans.options.excludeVAT,
  // entertainment: state.basket.entertainment,
  // pageToShowEntertainment: state.plans.options.pageToShowEntertainment,
  // getPlanOptionWithName: getPlanOptionWithName(state)
})

const mapDispatchToProps = dispatch => ({
  onBuildPlan: (upfront, duration, data, cost) =>
    dispatch(builtPlan(upfront, duration, data, cost)),
  gotoNextPage: () => dispatch(nextPage()),
  gotoPrevPage: () => dispatch(prevPage())
  // selectPlan: planID => dispatch(selectPlan(planID)),
  // jumpPage: () => dispatch(jumpPage()),
  // addEntertainment: (entertainmentCost, planID) =>
  //   dispatch(addEntertainment(entertainmentCost, planID))
})

export default connect(mapStateToProps, mapDispatchToProps)(BuildPlanPage)
